(() => {
  const KLAVIYO_COMPANY_ID = 'Rjrd2T';
  const KLAVIYO_REVISION = '2026-07-15';
  const RSVP_HASH = '#bear-sinister-rsvp';
  if (window.__bearSinisterEvent) return;
  window.__bearSinisterEvent = true;

  const scrollToRsvp = (target, keyboard = false) => {
    const stickyHeader = document.querySelector('.header__outer-wrapper');
    const eventRoot = document.querySelector('[data-bsm-root]');
    const dockOffset = eventRoot ? parseFloat(getComputedStyle(eventRoot).getPropertyValue('--bsm-dock-height')) || 0 : 0;
    const headerOffset = (stickyHeader ? stickyHeader.getBoundingClientRect().height : 0) + dockOffset;
    const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset - 20);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: reduced || keyboard ? 'instant' : 'smooth' });
  };

  const initializeRsvpScrollLinks = () => {
    document.querySelectorAll(`a[href="${RSVP_HASH}"]`).forEach((link) => {
      if (link.dataset.bs3ScrollReady === 'true') return;
      link.dataset.bs3ScrollReady = 'true';

      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        // Put the form in view, rather than the preceding prize explanation.
        const target = document.querySelector(RSVP_HASH);
        if (!target) return;

        event.preventDefault();
        scrollToRsvp(target, event.detail === 0);
        if (event.detail === 0) {
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      });
    });
  };

  const subscribe = async ({ listId, email, source }) => {
    const subscriptions = {
      email: { marketing: { consent: 'SUBSCRIBED' } }
    };

    const attributes = {
      email,
      properties: {
        event_name: 'Bear Sinister 3',
        event_date: '2026-10-10',
        event_interest: true,
        rsvp_source: source
      },
      subscriptions
    };

    const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes } }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    });

    if (!response.ok) throw new Error('subscription_failed');
  };

  const initialize = (form) => {
    if (form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    const submitButton = form.querySelector('[data-bs3-submit]');
    const errorMessage = form.querySelector('[data-bs3-error]');
    const successMessage = form.querySelector('[data-bs3-success]');
    submitButton.disabled = false;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      errorMessage.hidden = true;

      const emailInput = form.querySelector('[name="email"]');
      const newsletterChoice = form.querySelector('[name="newsletter"]');
      const email = emailInput.value.trim();

      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'ADDING YOU...';

      try {
        await subscribe({
          listId: form.dataset.eventList,
          email,
          source: 'Bear Sinister 3 RSVP'
        });

        if (newsletterChoice.checked) {
          await subscribe({
            listId: form.dataset.newsletterList,
            email,
            source: 'Bear Sinister 3 RSVP Brand Opt-In'
          });
        }

        Array.from(form.children).forEach((child) => {
          if (child !== successMessage) child.hidden = true;
        });
        successMessage.hidden = false;
        successMessage.focus();
      } catch (error) {
        errorMessage.textContent = 'Something went wrong. Please try again.';
        errorMessage.hidden = false;
        submitButton.disabled = false;
        submitButton.textContent = 'RSVP + ENTER TO WIN';
      }
    });
  };

  const boot = () => {
    initializeRsvpScrollLinks();
    document.querySelectorAll('[data-bs3-rsvp]').forEach(initialize);
  };
  const bootParsed = () => {
    if (document.readyState === 'loading') return;
    document.removeEventListener('readystatechange', bootParsed);
    boot();
  };
  if (document.readyState === 'loading') document.addEventListener('readystatechange', bootParsed);
  else bootParsed();
  document.addEventListener('shopify:section:load', boot);
})();
